import React from "react";
import FloodNotice from "./FloodNotice";
import {
  statusLabels,
  scopeLabels,
  displayDate,
  metricValue,
} from "@/lib/evidencePresentation";
export default function MetricCard({ metric }) {
  const flood = metric.id === "flood" && metric.status !== "unavailable";
  return (
    <article
      className={`research-card evidence-card status-${metric.status}`}
      id={`metric-${metric.id}`}
    >
      <span className={`evidence-status status-${metric.status}`}>
        {metric.status === "unavailable"
          ? "Evidence unavailable"
          : statusLabels[metric.status] || "Evidence unavailable"}
      </span>
      <h3>{metric.label}</h3>
      <strong>{metricValue(metric)}</strong>
      <p className="source">
        {metric.status === "user_provided"
          ? "Your input · not independently verified"
          : metric.status === "unavailable"
            ? "Verified evidence is not connected yet."
            : `${metric.status === "stale" ? "Cached, older evidence · " : ""}${metric.source_name} · ${metric.observation_period}`}
      </p>
      {flood ? (
        <FloodNotice />
      ) : (
        metric.derivation && <p className="source">{metric.derivation}</p>
      )}
      {metric.attribution && (
        <p className="source">
          {metric.attribution} · {metric.licence}
        </p>
      )}
      {metric.source_url && <a href={metric.source_url}>View source</a>}
      <dl className="evidence-provenance">
        <div>
          <dt>Scope</dt>
          <dd>
            {metric.geography_type
              ? `${scopeLabels[metric.geography_type] || metric.geography_type}${metric.geography_id ? ` · ${metric.geography_id}` : ""}`
              : metric.status === "user_provided"
                ? "Confirmed property input"
                : metric.status === "calculated"
                  ? "Your scenario assumptions"
                  : "Not established"}
          </dd>
        </div>
        <div>
          <dt>Source period</dt>
          <dd>{metric.observation_period || "Not recorded"}</dd>
        </div>
        {metric.retrieved_at && (
          <div>
            <dt>Retrieved</dt>
            <dd>{displayDate(metric.retrieved_at)}</dd>
          </div>
        )}
      </dl>
      {metric.status === "unavailable" && (
        <p className="source">
          Missing evidence does not establish low risk. Check the relevant
          authority before relying on this item.
        </p>
      )}
    </article>
  );
}
